var _path, _g, _path2, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 24,
    width: 413,
    height: 465
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.688 135.802L462 131.49V471.393C462 480.905 454.296 488.599 444.794 488.599H66.2063C56.7135 488.599 49 480.895 49 471.393V41.2063C49 31.6939 56.7233 24 66.2063 24H345.896L457.688 135.802Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4425.05,
    y: -1533.32,
    width: 6883.14,
    height: 5162.36,
    fill: "#CFD8DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 342,
    y: 24,
    width: 121,
    height: 121
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342 122.506C342 134.609 351.806 144.405 363.899 144.405H462.405L342 24V122.506Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4405,
    y: -1553,
    width: 6883.14,
    height: 5162.36,
    fill: "#B1BEC6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.891 293.517V281.816C226.891 273.925 227.753 267.485 229.476 262.496C231.29 257.417 234.148 253.063 238.048 249.435C241.948 245.716 247.254 242.133 253.966 238.687C259.953 235.512 264.624 232.609 267.98 229.979C271.427 227.258 273.876 224.401 275.327 221.408C276.778 218.414 277.504 214.832 277.504 210.659C277.504 204.129 274.873 198.732 269.613 194.469C264.352 190.115 257.096 187.938 247.844 187.938C237.413 187.938 229.386 190.115 223.762 194.469C218.229 198.822 214.873 204.718 213.694 212.156H186.483C187.662 197.825 193.331 186.305 203.49 177.598C213.649 168.89 228.161 164.537 247.028 164.537C259.182 164.537 269.658 166.623 278.456 170.795C287.254 174.877 294.012 180.455 298.728 187.53C303.445 194.605 305.803 202.451 305.803 211.067C305.803 220.41 303.445 228.301 298.728 234.741C294.012 241.181 286.484 247.077 276.143 252.428C270.157 255.603 265.44 258.596 261.994 261.408C258.547 264.129 256.098 267.213 254.647 270.66C253.286 274.106 252.606 278.551 252.606 283.993V293.517H226.891ZM240.361 344.537C234.919 344.537 230.474 342.814 227.027 339.367C223.581 335.921 221.857 331.748 221.857 326.85C221.857 321.771 223.535 317.462 226.891 313.925C230.338 310.388 234.783 308.619 240.225 308.619C245.667 308.619 250.202 310.388 253.83 313.925C257.549 317.372 259.409 321.635 259.409 326.714C259.409 331.612 257.594 335.83 253.966 339.367C250.338 342.814 245.803 344.537 240.361 344.537Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.392f9169c3566fd80d5f793dd7774983.svg";
export { ForwardRef as ReactComponent };